import { useCallback, useEffect, useState } from 'react'
import { handleErrorNotification } from 'services/ErrorHandlingService'
import {
  IBusinessUpshifter,
  SORTING_DIRECTION,
  TGetBusinessUpshiftersParams,
} from 'models/BusinessUpshifter'
import { useSelector } from 'react-redux'
import { selectBusinessEntity } from '@src/data/BusinessEntity/selectors'
import { API } from '@src/network'

export const useRosterMembersData = (
  rosterId: number,
  isExpanded: boolean,
  businessId?: number
) => {
  const [isFetching, setIsFetching] = useState(false)
  const [error, setError] = useState<string>()
  const [members, setMembers] = useState<IBusinessUpshifter[]>()
  const businessEntity = useSelector(selectBusinessEntity)
  const fetchMembers = useCallback(async () => {
    try {
      setIsFetching(true)
      const params: TGetBusinessUpshiftersParams = {
        business_id: businessEntity?.id ?? businessId,
        roster_ids: [rosterId],
        order_by: 'hours_worked_last_month_or_year',
        order_by_direction: SORTING_DIRECTION.DESC,
        include: {
          last_completed_punch_card: {
            business_id: businessEntity?.id ?? businessId,
          },
          finished_punch_cards_sum_hours_total: {
            business_id: businessEntity?.id ?? businessId,
          },
          finished_punch_cards_thirty_trailing_days_sum_hours_total:
            'finished_punch_cards_thirty_trailing_days_sum_hours_total',
        },
      }
      const response = await API.BusinessUpshifters.getBusinessUpshifters(params)
      setMembers(response.data)
    } catch (error) {
      setError(error)
      handleErrorNotification(error)
    } finally {
      setIsFetching(false)
    }
  }, [businessEntity?.id, businessId, rosterId])

  useEffect(() => {
    if (isExpanded && !isFetching && !members && !error) {
      fetchMembers()
    }
  }, [fetchMembers, isExpanded, isFetching, members, error])

  return { isFetching, members, error }
}
